module.exports = __webpack_public_path__ + "static/forbes_partner_logo-64a2ab5fd63e68d781fb8e2a02180c18.png";